export default {"src":"/_next/static/media/canara.9719a798.svg","height":84,"width":121,"blurWidth":0,"blurHeight":0};